define('C3.ShoppingExtensions.HeaderMenu.MyAccountMobile.View'
, 	[
		'c3_myaccount_mobile.tpl',
        'Profile.Model',
        //'SC.Configuration',
        'Utils',
        'Header.Menu.MyAccount.View',
        'Header.Menu.View',
        'C3.ShoppingExtensions.HeaderMenu.MobileMyAccount.Sidebar',
		'SCView',
        'jQuery.sidebarMenuCustom'
	],
function (
		c3_myaccount_mobile_tpl,
        ProfileModel,
       // Configuration,
        Utils,
        HeaderMenuMyAccountView,
        HeaderMenuView,
        HeaderExtensionMobileMyAccountSidebar,
		SCViewModule
){
	'use strict';

	 var SCView = SCViewModule.SCView;

	  function HeaderMenuMyAccountMobileView (options) {
        SCView.call(this, options);

        this.template = c3_myaccount_mobile_tpl;
        this.options = options;
        this.application = options.application;

        this.showMyAccountMenu = function showMyAccountMenu () {
           // console.log('showMyAccountMenu')
            jQuery('html').css('background','none');
            jQuery('.main').addClass('header-sidebar-opened-myaccount-sidebar');
            jQuery('.sidebar-close-myaccount-mobile').show();
            jQuery('.facets-facet-browse-facets').hide();
            jQuery('.header-secondary-wrapper-relatedcategories-mobile').hide();

            jQuery('.product-list-details-later-row').hide();

            jQuery('.wishlist-secondary-wrapper-sec').hide();
            jQuery('.wishlist-sidebar-overlay-sec').hide();

            jQuery('.header-sidebar-overlay-mobile').show();
            jQuery('.header-sidebar-relatedcategories-overlay-mobile').hide();

            //if(jQuery('.shopping-layout-header').hasClass('shopping-layout-header-no-hamburger-scroll'))
            jQuery('.shopping-layout-header').removeClass('shopping-layout-header-no-hamburger-scroll')
            jQuery('.myaccount-layout-header').removeClass('myaccount-layout-header-no-hamburger-scroll')
        }

        this.hideSidebar = function hideSidebar(e) {
           var dontCloseFlag = false;

            if (e.target.tagName === 'A') {
                if (this.activeLink) {
                    this.activeLink.removeClass('active');
                }
                this.activeLink = jQuery(e.target);
                this.activeLink.addClass('active');
            }else if(e.target.tagName === 'SPAN')
            {
                dontCloseFlag = true;
            } 

            if(dontCloseFlag == false)
            {
            jQuery('.main').removeClass('header-sidebar-opened-myaccount-sidebar');
            jQuery('.sidebar-close-myaccount-mobile').hide();

            jQuery('.facets-facet-browse-facets').show();
            jQuery('.header-secondary-wrapper-relatedcategories-mobile').show();
            jQuery('.wishlist-secondary-wrapper-sec').show();
            jQuery('.wishlist-sidebar-overlay-sec').show();

            jQuery('.header-sidebar-overlay-mobile').hide();
            jQuery('.header-sidebar-relatedcategories-overlay-mobile').show();

            jQuery('.shopping-layout-header').addClass('shopping-layout-header-no-hamburger-scroll')
            jQuery('.myaccount-layout-header').addClass('myaccount-layout-header-no-hamburger-scroll')

            jQuery('.product-list-details-later-row').show();
            }  
        }

    }

    HeaderMenuMyAccountMobileView.prototype = Object.create(SCView.prototype);
    HeaderMenuMyAccountMobileView.prototype.constructor = HeaderMenuMyAccountMobileView;

    /*HeaderMenuMyAccountMobileView.prototype.initialize = function (options) {
        this.options = options;
    }*/

    HeaderMenuMyAccountMobileView.prototype.getEvents = function() {
            return {
                'click [data-action="header-sidebar-show1"]':'showMyAccountMenu',
                'click [data-action="header-sidebar-hide"]': 'hideSidebar',
                'click [data-type="header-sidebar-menu-mobile"]': 'hideSidebar'
            };
        }

    /*HeaderMenuMyAccountMobileView.prototype.getChildViews = function() {
        console.log('getChildViews')
        return {
            'Header.Sidebar.Mobile.MyAccount.Menu': function() {
                return new HeaderMenuMyAccountView(
                        {
                            application: this.application
                });
            },
            'C3.MyAccount.Mobile.Header.Menu': function() {
                var header_view_options = _.extend(
                    {
                        application: this.application
                    },
                    {}
                );

                return new HeaderExtensionMobileMyAccountSidebar(header_view_options);
            }
        }
    }*/    

    HeaderMenuMyAccountMobileView.prototype.render = function () {
        SCView.prototype.render.call(this);
        this.$('[data-type="header-sidebar-menu-mobile"]').sidebarMenu1();
    }
    HeaderMenuMyAccountMobileView.prototype.getContext = function () {
    	var Configuration = this.application.Configuration

        var profile = ProfileModel.getInstance()
        ,   is_loading = !Configuration.get('performance.waitForUserProfile', true) && ProfileModel.getPromise().state() !== 'resolved'
        ,   is_logged_in = profile.get('isLoggedIn') === 'T' && profile.get('isGuest') === 'F'
        
        return {
           isLoggedIn : !is_loading && is_logged_in,
           isPhoneDevice: Utils.isPhoneDevice()
        }
    }

    return HeaderMenuMyAccountMobileView
});
